import { html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { BaseElement } from '../base/base-element.js';

@customElement('session-list')
export class SessionList extends BaseElement {
    static styles = [
        BaseElement.styles,
        css`
            :host {
                display: flex;
                flex-wrap: wrap;
                gap: 0.5rem;
                justify-content: center;
                min-height: 2.5rem;
            }

            .session-item {
                padding: 0.5rem 1rem;
                font-size: 1.25rem;
                font-weight: 700;
                font-family: 'Courier New', Courier, monospace;
                letter-spacing: 0.15em;
                background-color: var(--primary-color);
                color: white;
                border: none;
                border-radius: 0.5rem;
                cursor: pointer;
                transition: background-color 0.2s, transform 0.1s;
            }

            .session-item:hover {
                background-color: var(--primary-hover);
                transform: scale(1.05);
            }

            .session-item:active {
                transform: scale(0.98);
            }

            .no-sessions-message {
                font-size: 0.875rem;
                color: var(--text-tertiary);
                font-style: italic;
            }
        `,
    ];

    @property({ attribute: false })
    sessions: { joinCode: string }[] = [];

    @property({ type: String })
    emptyMessage = 'No active sessions';

    private _onSessionClick(joinCode: string) {
        this.dispatchEvent(
            new CustomEvent('session-join', {
                bubbles: true,
                composed: true,
                detail: { joinCode },
            })
        );
    }

    render() {
        if (this.sessions.length === 0) {
            return html`<p class="no-sessions-message">${this.emptyMessage}</p>`;
        }

        return html`${this.sessions.map(
            (session) => html`
                <button
                    class="session-item"
                    @click=${() => this._onSessionClick(session.joinCode)}
                >
                    ${session.joinCode}
                </button>
            `
        )}`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'session-list': SessionList;
    }
}
